import React, { useCallback, useEffect } from 'react';

import { Button } from 'antd';

import CopyText from 'v2/components/Shared/CopyText';
import type { IContentDelivery } from 'v2/interfaces/product';
import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import productService from 'v2/services/product';

import BankSlipInstallment from './bankSlipIntallment';
import { BuyerDetails } from './buyerDetails';
import GetCcbTerm from './CcbTerm/getCcbTerm';
import { ChangePaymentMethod } from './changePaymentMethod';
import InvoiceDetails from './invoiceDetails';
import { PaymentHistory } from './paymentHistory';
import ProducerContact from './producerContact';
import RefundActions from './refundActions';
import RefundStatus from './refundStatus';

interface InfoProps {
  delivery: ShoppingDelivery;
  closeQuickView: () => void;
}

const Info = ({ delivery, closeQuickView }: InfoProps) => {
  const [contentDelivery, setContentDelivery] = React.useState<IContentDelivery>({
    delivery_nutror: false,
    download_hash: false
  });

  useEffect(() => {
    const fetchContentDelivery = async () => {
      setContentDelivery(await productService.getContentDelivery(delivery.product.id));
    };

    fetchContentDelivery();
  }, [delivery.product.id]);

  const handleClickAccessContent = useCallback(() => {
    window.open('https://app.nutror.com');
  }, []);

  const handleClickDownload = useCallback((hash: string | boolean) => {
    window.open('/downloads/' + hash, '_blank');
  }, []);

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex flex-col gap-3 sm:flex-row'>
        <div
          className='h-28 w-28 max-w-28 shrink-0 rounded bg-neutral-50 bg-cover bg-center bg-no-repeat'
          style={{ backgroundImage: `url(${delivery.product.image})` }}
        />

        <div>
          <h2 className='mb-4 text-base'>{delivery.product.title}</h2>
          {!delivery?.producer.showProducerContactInformation && (
            <div className='text-sm'>
              <span className='font-semibold'>Produtor:</span>
              <div className='text-content-subtitle block'>{delivery.producer.name}</div>
              <div className='text-content-subtitle block'>
                <CopyText value={delivery.producer.email} />
              </div>
            </div>
          )}
        </div>
      </div>

      <BuyerDetails delivery={delivery} />

      <div>
        {!delivery.unlimited_installment && !delivery?.bankslip_installments && <InvoiceDetails delivery={delivery} />}

        {!delivery.unlimited_installment && delivery?.bankslip_installments && (
          <BankSlipInstallment delivery={delivery} />
        )}

        {delivery.unlimited_installment && <PaymentHistory delivery={delivery} />}
      </div>

      {delivery?.producer.showProducerContactInformation && <ProducerContact delivery={delivery} />}

      <div className='flex flex-col gap-3'>
        {contentDelivery.delivery_nutror && (
          <Button onClick={handleClickAccessContent} block>
            Acessar conteúdo
          </Button>
        )}
        {delivery.unlimited_installment && <ChangePaymentMethod delivery={delivery} closeQuickView={closeQuickView} />}
        <RefundActions delivery={delivery} />
        {contentDelivery.download_hash && (
          <Button onClick={() => handleClickDownload(contentDelivery.download_hash)} block>
            Download Materiais
          </Button>
        )}
        <GetCcbTerm delivery={delivery} />
      </div>

      <RefundStatus delivery={delivery} />
    </div>
  );
};

export default Info;
